import { Component, input } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import {
	StatusTrackingDto,
	VehicleTypeEnum,
} from '@splitsecondconnect/ultramarine-shared';

import { LocationLinkCardComponent } from 'app/modules/admin/locations/components/location-link-card/location-link-card.component';
import { VehicleCategoryLinkCardComponent } from 'app/modules/admin/vehicle-categories/components/vehicle-category-link-card/vehicle-category-link-card.component';
import { ModuleSelectorComponent } from 'app/shared/components/module-selector/module-selector.component';
import { SummaryBoxItemComponent } from 'shared/components/summary-box-item/summary-box-item.component';
import { SummaryBriefComponent } from 'shared/components/summary-brief/summary-brief.component';

import { SummaryItemComponent } from '../../../../../../../shared/components/summary-item/summary-item.component';
import { BaseSummarySectionComponent } from '../../../../../../shared/base-classes/sections/base-summary-section.component';
import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { GetTranslationKeyForValuePipe } from '../../../../../../shared/components/dropdowns/filter-multiselect-dropdown/get-translation-key-for-value.pipe';
import { GetIconFromOptionsPipe } from '../../../../../../shared/pipes/get-icon-from-options.pipe';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import {
	VEHICLE_TYPE,
	VEHICLE_FUEL_TYPE,
	VEHICLE_STEERING_POSITION,
} from '../../../translations/vehicles-select-items';

import { VehicleLinksStatusComponent } from './components/vehicle-links-status/vehicle-links-status.component';

@Component({
	selector: 'app-vehicles-summary',
	templateUrl: 'vehicles-summary.component.html',
	imports: [
		ReactiveFormsModule,
		SectionWrapperComponent,
		SummaryItemComponent,
		SummaryBoxItemComponent,
		VehicleLinksStatusComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
		SummaryBoxItemComponent,
		VehicleCategoryLinkCardComponent,
		LocationLinkCardComponent,
		GetTranslationKeyForValuePipe,
		TranslocoModule,
		SummaryBriefComponent,
		GetIconFromOptionsPipe,
		ModuleSelectorComponent,
	],
})
export class VehiclesSummaryComponent<
	T,
> extends BaseSummarySectionComponent<VehicleRecordModel> {
	statusTracking = input<StatusTrackingDto<T>[]>(null);
	protected _skipCount: number = 0;

	vehicleTypeEnum = VehicleTypeEnum;
	vehicleFuelTypes = VEHICLE_FUEL_TYPE;
	typeOptions = VEHICLE_TYPE;
	steeringPositions = VEHICLE_STEERING_POSITION;

	constructor(private _formBuilder: FormBuilder) {
		super();
		this.detailsForm = this._formBuilder.group({
			tags: [null],
		});
	}

	protected _mapModelToForm(): void {
		const detailsFormData: any = {
			tags: this.recordData().tags,
		};
		this.detailsForm.setValue(detailsFormData);
	}

	protected _mapFormToModel(): Partial<VehicleRecordModel> {
		return {
			tags: this.detailsForm.value.tags,
		};
	}
}
